import * as React from 'react';
import * as styles from "./AIAssistant.css";
import { IASkeleton } from '../skeleton/Skeleton';
import { LocalizationService } from '../../services/LocalizationService';

export interface IProps {
}

export interface IState {
  status?: string;
}

export default class AiAssistantPanel extends React.Component<IProps, IState> {

  private localizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.setState({
      status: this.localizationService.strings.AIAssistant_searchingForAnswers
    }, () => {
      setTimeout(() => {
        this.setState({
          status: this.localizationService.strings.AIAssistant_stillSearchingForAnswers
        })
      }, 2000);
      setTimeout(() => {
        this.setState({
          status: this.localizationService.strings.AIAssistant_itIsTakingALittleLonger
        })
      }, 6000);
      setTimeout(() => {
        this.setState({
          status: this.localizationService.strings.AIAssistant_stillSearchingForAnswers
        })
      }, 8000);
    })
  }

  public render() {
    return (
      <div className={styles.IA_aiResponseCardWrapper}>
        <div className={styles.IA_aiResponseCard}>
          <IASkeleton skeleton={{ height: 16, width: "100%", borderRadius: 5 }} />
          <IASkeleton skeleton={{ height: 16, width: "100%", borderRadius: 5, marginTop: 10 }} />
          <IASkeleton skeleton={{ height: 16, width: "100%", borderRadius: 5, marginTop: 10 }} />
          <IASkeleton skeleton={{ height: 16, width: "33%", borderRadius: 5, marginTop: 10 }} />
          <div className={styles.IA_aiResponseCardSourcesWrapper} style={{ marginTop: 10 }}>
            <IASkeleton skeleton={{ height: 30, width: 134, borderRadius: 5, marginRight: 10, marginTop: 10 }} />
            <IASkeleton skeleton={{ height: 30, width: 89, borderRadius: 5, marginRight: 10, marginTop: 10 }} />
            <IASkeleton skeleton={{ height: 30, width: 178, borderRadius: 5, marginRight: 10, marginTop: 10 }} />
          </div>
        </div>
        <div className={styles.IA_searchStatus}>{this.state.status}</div>
      </div>
    );
  }
}